import {
  GET_SERVICE_LIST,
  GET_SERVICE_LIST_SUCCESS,
  GET_SERVICE_LIST_FAIL,
  POST_ADD_SERVICE,
  POST_ADD_SERVICE_SUCCESS,
  POST_ADD_SERVICE_FAIL,
  GET_AVAILABLE_SERVICES,
  GET_AVAILABLE_SERVICES_SUCCESS,
  GET_AVAILABLE_SERVICES_FAIL,
  POST_UPDATE_SERVICES,
  POST_UPDATE_SERVICES_SUCCESS,
  POST_UPDATE_SERVICES_FAIL,
  GET_SERVICE_ID,
  GET_SERVICE_ID_SUCCESS,
  GET_SERVICE_ID_FAIL,
  POST_DELETE_SERVICE,
  POST_DELETE_SERVICE_FAIL,
  POST_DELETE_SERVICE_SUCCESS,
  GET_ACTIVE_SERVICES,
  GET_ACTIVE_SERVICES_SUCCESS,
  GET_ACTIVE_SERVICES_FAIL,
  POST_TIME_ZONE,
  POST_TIME_ZONE_SUCCESS,
  POST_TIME_ZONE_FAIL,
} from "./actionTypes";

export const postTimeZone = data => ({
  type: POST_TIME_ZONE,
  payload: data,
});
export const postTimeZoneSuccess = data => ({
  type: POST_TIME_ZONE_SUCCESS,
  payload: data,
});
export const postTimeZoneFail = error => ({
  type: POST_TIME_ZONE_FAIL,
  payload: error,
});

export const getServicesByStateActive = (data = {}) => ({
  type: GET_ACTIVE_SERVICES,
  payload: data,
});
export const getServicesByStateActiveSuccess = data => ({
  type: GET_ACTIVE_SERVICES_SUCCESS,
  payload: data,
});
export const getServicesByStateActiveFail = error => ({
  type: GET_ACTIVE_SERVICES_FAIL,
  payload: error,
});
export const postDeleteService = data => ({
  type: POST_DELETE_SERVICE,
  payload: data,
});
export const postDeleteServiceSuccess = data => ({
  type: POST_DELETE_SERVICE_SUCCESS,
  payload: data,
});
export const postDeleteServiceFail = error => ({
  type: POST_DELETE_SERVICE_FAIL,
  payload: error,
});
export const getServiceId = data => ({
  type: GET_SERVICE_ID,
  payload: data,
});
export const getServiceIdSuccess = data => ({
  type: GET_SERVICE_ID_SUCCESS,
  payload: data,
});
export const getServiceIdFail = error => ({
  type: GET_SERVICE_ID_FAIL,
  payload: error,
});
export const updateService = data => ({
  type: POST_UPDATE_SERVICES,
  payload: data,
});
export const updateServiceSuccess = data => ({
  type: POST_UPDATE_SERVICES_SUCCESS,
  payload: data,
});
export const updateServiceFail = error => ({
  type: POST_UPDATE_SERVICES_FAIL,
  payload: error,
});

export const getServiceList = (data = {}) => ({
  type: GET_SERVICE_LIST,
  payload: data,
});

export const getServiceListSuccess = data => ({
  type: GET_SERVICE_LIST_SUCCESS,
  payload: data,
});

export const getServiceListFail = error => ({
  type: GET_SERVICE_LIST_FAIL,
  payload: error,
});

export const postService = data => ({
  type: POST_ADD_SERVICE,
  payload: data,
});

export const postServiceSuccess = data => ({
  type: POST_ADD_SERVICE_SUCCESS,
  payload: data,
});

export const postServiceFail = error => ({
  type: POST_ADD_SERVICE_FAIL,
  payload: error,
});

export const getAvailableServices = data => ({
  type: GET_AVAILABLE_SERVICES,
  payload: data,
});

export const getAvailableServicesSuccess = services => ({
  type: GET_AVAILABLE_SERVICES_SUCCESS,
  payload: services,
});

export const getAvailableServicesFail = error => ({
  type: GET_AVAILABLE_SERVICES_FAIL,
  payload: error,
});
